import { blogPosts } from '@/mocks/blogPosts';
import Reveal from '@/components/base/Reveal';
import { useCatalogVersion } from '@/lib/catalogStore';

export default function BlogSection() {
  useCatalogVersion();
  const items = blogPosts.slice(0, 4);

  if (items.length === 0) return null;

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <Reveal>
          <div className="flex items-end justify-between gap-4">
            <div>
              <span className="text-xs font-mono uppercase tracking-[0.25em] text-primary-500 whitespace-nowrap">
                ai insights
              </span>
              <h2 className="mt-3 font-display text-3xl md:text-4xl font-normal tracking-tight text-white">
                AI 최신소식 &amp; AI부업소식
              </h2>
            </div>
            <a
              href="/blog"
              className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              전체보기
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {items.map((post, index) => (
            <Reveal key={post.id} delay={(index % 4) * 60}>
              <a
                href={`/blog/${post.id}`}
                className="group block rounded-2xl overflow-hidden bg-background-100 border border-white/5 hover:border-primary-500/40 transition-all cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    loading="lazy"
                    decoding="async"
                    src={post.coverImageUrl}
                    alt={post.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    onError={(e) => {
                      (e.currentTarget as HTMLImageElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                </div>

                <div className="p-4">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{post.authorName}</span>
                    <span>·</span>
                    <span>{post.createdAt}</span>
                  </div>
                  <h3 className="mt-2 font-heading font-semibold text-foreground-100 group-hover:text-white transition-colors text-sm line-clamp-2">
                    {post.title}
                  </h3>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-8 sm:hidden text-center">
          <a
            href="/blog"
            className="inline-flex items-center gap-1 text-sm font-medium text-foreground-400 hover:text-white transition-colors cursor-pointer"
          >
            전체보기
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
